import { useEffect } from 'react'
import { isMobile } from '../../utils/HTMLutils'
import { scrollSmooth } from '../../utils/ScrollUtils'

export default function useDraggableContainer(
  queryContainer: string,
  size?: number
) {
  useEffect(() => {
    let timeout: any = null
    const element = document.querySelector(queryContainer) as any
    element.style.cursor =
      element.scrollWidth > element.clientWidth ? 'grab' : 'default'
    let pos = { left: 0, x: 0 }
    let moving = false

    const mouseDownHandler = (evt: any) => {
      if (timeout) clearTimeout(timeout)

      if (evt.button === 0 && element.scrollWidth > element.clientWidth) {
        element.style.scrollSnapType = 'none'
        element.style.cursor = '-webkit-grabbing'
        element.style.cursor = 'grabbing'
        moving = true
        pos = {
          left: element.scrollLeft,
          x: evt.clientX
        }
      }
    }
    const mouseOverHandler = () => {
      if (!moving) {
        element.style.cursor =
          element.scrollWidth > element.clientWidth ? 'grab' : ''
      }
    }

    const mouseMoveHandler = (evt: any) => {
      const dx = evt.clientX - pos.x

      // Scroll the element
      if (moving) {
        element.style.cursor = '-webkit-grabbing'
        element.style.cursor = 'grabbing'
        element.scrollLeft = pos.left - dx
      }
    }

    const mouseUpHandler = () => {
      moving = false
      element.style.cursor =
        element.scrollWidth > element.clientWidth ? 'grab' : ''

      if (size) {
        const width = element.scrollWidth / (size || 1)
        const newAtual = Math.round(element.scrollLeft / width)
        scrollSmooth({
          top: 0,
          left: width * newAtual,
          behavior: 'smooth',
          element: element,
          duration: 500
        })
      }

      if (timeout) clearTimeout(timeout)
      timeout = setTimeout(
        () => {
          element.style.scrollSnapType = ''
        },
        size ? 550 : 1
      )
    }

    if (!isMobile()) {
      element.addEventListener('mouseover', mouseOverHandler)
      element.addEventListener('mousedown', mouseDownHandler)
      document.addEventListener('mousemove', mouseMoveHandler)
      document.addEventListener('mouseup', mouseUpHandler)
    }
    return () => {
      if (!isMobile()) {
        element.removeEventListener('mouseover', mouseOverHandler)
        element.removeEventListener('mousedown', mouseDownHandler)
        document.removeEventListener('mousemove', mouseMoveHandler)
        document.removeEventListener('mouseup', mouseUpHandler)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
